<template>
  <div class="fasciaBoard">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>Exhibiting</BreadcrumbItem>
          <BreadcrumbItem>Fascia (Shell Scheme Only)</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibitionEn/index/exinfo/fascia-alter');">
          <span>Back</span>
        </div>
      </div>
    </div>

    <div class="fasciaBoard-content">
      <Form
        ref="formInline"
        :model="formInline"
        :rules="ruleInline"
        label-position="right"
        :label-width="140"
        @submit.native.prevent
      >
        <FormItem label="Exhibition Hall：">
          <Input style="width:580px;" type="text" v-model="formInline.exArea" disabled />
        </FormItem>
        <FormItem label="Booth number：">
          <Input style="width:580px;" type="text" v-model="formInline.exHall" disabled />
        </FormItem>
        <FormItem label="Company name：" prop="comName">
          <Input style="width:580px;" type="text" v-model="formInline.comName" />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formInline')"
            style="width: 154px;height:36px;"
            :loading="loading"
          >Save</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
import config from "@assets/config.json";

export default {
  name: "exhibition-info-fasciaBoard",
  data() {
    return {
      formInline: {
        exArea: "", // 展区
        exHall: "", // 展位号
        comName: "", // 公司中文名
      },
      ruleInline: {
        comName: [
          { required: true, message: "Company name cannot be empty", trigger: "blur" }
        ],
      },
      loading: false,
      fasciaBoardIsHave: false,
      fasciaBoardInfo: null,
      fasciaBoardDownInfo: null
    };
  },
  computed: {
    ...mapGetters({
      joinInfo: "loginModule/getJoinInfo",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    exhibitionId() {
      return this.exhibition.id;
    }
  },
  created() {
    document.title = "国际焙烤展 - Fascia (Shell Scheme Only)";
    this.init();
  },
  methods: {
    ...mapActions({
      getFasciaBoardDown: "exhibitionModule/getFasciaBoardDown",
      editFasciaBoardDown: "exhibitionModule/editFasciaBoardDown",
    }),
    async init() {
      // if (this.joinInfo && this.joinInfo.boothInfo) {
      //   let boothInfo = JSON.parse(this.joinInfo.boothInfo);
      //   this.formInline.exArea = this.joinInfo.exArea;
      //   for (let i = 0; i < boothInfo.length; i++) {
      //     if (boothInfo.length > 1) {
      //       this.formInline.exHall +=
      //         boothInfo[i].Hall + "-" + boothInfo[i].Code + "、";
      //     } else {
      //       this.formInline.exHall +=
      //         boothInfo[i].Hall + "-" + boothInfo[i].Code;
      //     }
      //   }
      // }
      if (this.joinInfo && this.joinInfo.exArea) {
        this.formInline.exArea = this.joinInfo.exArea;
      }
      if (this.joinInfo && this.joinInfo.boothInfo && this.joinInfo.boothInfo.length) {
        if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object String]') {
          if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
            this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
          }
        }
        if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object Object]') {
          if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
            this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
          }
          if (this.joinInfo.boothInfo.Hall) {
            this.formInline.exHall = this.joinInfo.boothInfo.Hall + "-" + this.joinInfo.boothInfo.Code;
          } else {
            this.formInline.exHall = this.joinInfo.boothInfo.Code;
          }
        }
        if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object Array]') {
          let boothInfo = this.joinInfo.boothInfo;
          for (let i = 0; i < boothInfo.length; i++) {
            if (boothInfo.length > 1) {
              if (boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "-" + boothInfo[i].Code + "、";
              }
              if (boothInfo[i].Hall && !boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "、";
              }
              if (!boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Code + "、";
              }
              
            } else {
              if (boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "-" + boothInfo[i].Code;
              }
              if (boothInfo[i].Hall && !boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall;
              }
              if (!boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Code;
              }

            }
          }
        }
        // this.formInline.exHall = boothInfo.Hall + '-' + boothInfo.Code;
      }

      // 获取楣板修改记录
      let result = await this.getFasciaBoardDown(this.joinInfo.joinId);
      if (result) {
        this.fasciaBoardDownInfo = result;
        this.formInline.comName = result.compName;
        console.log("fasciaBoardDownInfo：",this.fasciaBoardDownInfo)
      }
    },
    async handleSubmit(name) {
      let valid = await this.validForm(name);
      if (!valid) return;

      let req = {
        CompName: this.formInline.comName,
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let opt = {
        Id: this.fasciaBoardDownInfo.id,
        SetValues: req
      };
      let result = await this.editFasciaBoardDown(opt);
      if (result && result.successed) {
        this.$Message.success("successful");
        this.$router.push("/exhibitionEn/index/exinfo/fascia-alter");
      } else {
        this.$Message.warning(`fail,please try again`);
      }
      setTimeout(() => {
        this.loading = false;
      },1000);
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.fasciaBoard {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 800px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
  }
}
</style>
